export const noDataViewClassName =
   'min-h-[156px] h-full flex flex-col items-center justify-center'

export const getTitleStyles = (theme: any): string =>
   `text-sm-medium ${theme.titleColor} mt-8px`
